import type { Product } from 'reactApp/types/Billing';
import { getPeriodName } from 'reactApp/utils/Period';
import { formatPrice, getMonthProductPrice } from 'reactApp/utils/priceHelpers';

interface Props {
    product: Product;
    periodDivider?: string;
    locale?: string;
}

export const getPrice = ({ product, periodDivider = ' / ', locale }: Props) => {
    const { price, discountPrice, discountPeriod, period } = product;
    const defaultPeriod = '1y';

    const priceAsText = price ? `${formatPrice(price, locale)} ₽ ${periodDivider} ${getPeriodName(period || defaultPeriod)}` : '';
    const discountPriceAsText = discountPrice
        ? `${formatPrice(discountPrice, locale)} ₽ ${periodDivider} ${getPeriodName(discountPeriod || defaultPeriod)}`
        : '';

    const productMonthPriceAsText = `${formatPrice(getMonthProductPrice(product), locale)} ₽ ${periodDivider} месяц`;
    const defaultMonthPrice = `${formatPrice(getMonthProductPrice(product, false), locale)} ₽`;
    const forceTrial = 'Месяц за 0 ₽';

    return [priceAsText, discountPrice, discountPriceAsText, productMonthPriceAsText, defaultMonthPrice, forceTrial] as const;
};
